import { useQueryClient } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';

import { useCarrinhoContext } from '../contexts';

import { useApiContext } from 'context/ApiContext';
import { useShowError } from 'hooks/useShowError';
import { getSuccessMessage, SuccessMessageProps } from 'util/success';

export function useDeletePedido() {
    const { showError } = useShowError();
    const { setDisabledActions } = useCarrinhoContext();
    const { api } = useApiContext();
    const queryClient = useQueryClient();

    /**
     * Exclui o rascunho e atualiza a lista de rascunhos e o totalizador.
     */
    const handleDelete = (idPedido: number) => {
        setDisabledActions(true);

        api.delete(`/compra/pedidowrapper/rascunho/${idPedido}`)
            .then((result: SuccessMessageProps) => {
                const message = getSuccessMessage(result);

                enqueueSnackbar(message, { variant: 'success' });

                queryClient.invalidateQueries({ queryKey: ['carrinho'] });
                queryClient.invalidateQueries({ queryKey: ['carrinho-totalizador'] });
            })
            .catch((error) => showError(error, 'Não foi possível remover o pedido. Tente novamente'))
            .finally(() => setDisabledActions(false));
    };

    return { handleDelete };
}
